"use strict";

function ClassicInvitationSamples(params) {
  var quantity = parseInt(params.quantity, 10);

  if (parseInt(params.sample_price, 10)) {
    this.paidClassicInvitationSamples.add({
      quantity: quantity
    });
  } else {
    this.freeClassicInvitationSamples.add({
      quantity: quantity
    });
  }
}

module.exports = ClassicInvitationSamples;